module.exports = __webpack_public_path__ + "img/lsd2.2e6d3310.png";